$(function () {
    $(window).on("load", function () {
        var csObj = new Object();
        csObj.horizontalScroll = true;
        $(".js-scroll01").mCustomScrollbar(csObj);

        var ua = navigator.userAgent;
        if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0 || ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
            $(".js-scroll02").mCustomScrollbar(csObj);
        }

        $('area').hover(
            function () {
                $(this).focus();
            },
            function () {
                $(this).blur();
            }
        )
        $('img[usemap]').rwdImageMaps();
    });
});